import { render, staticRenderFns } from "./KeHuSiXiangZS.vue?vue&type=template&id=24ea5a8b&scoped=true&"
import script from "./KeHuSiXiangZS.vue?vue&type=script&lang=js&"
export * from "./KeHuSiXiangZS.vue?vue&type=script&lang=js&"
import style0 from "./KeHuSiXiangZS.vue?vue&type=style&index=0&id=24ea5a8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ea5a8b",
  null
  
)

export default component.exports